import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Button from 'components/common/Button';

const propTypes = {
  children: PropTypes.any,
  type: PropTypes.string,
  mod: PropTypes.string,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  Title: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]),
  ContentWrapper: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]),
  ButtonOpen: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]),
  ButtonClose: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]),
  ButtonCloseMobile: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]),
  defaultOpened: PropTypes.bool,
};

/* eslint-disable react/prop-types */
const defaultProps = {
  Title: () => (<span />),
  ContentWrapper: ({ children }) => (children),
  ButtonOpen: ({ onClick, isDisabled }) => (
    <Button btnType="secondary" onClick={onClick} disabled={isDisabled} isFullWidth>
      <FormattedMessage id="collapsible.show" />
    </Button>
  ),
  ButtonClose: ({ onClick }) => (
    <button type="button" className="collapsible__close" onClick={onClick} />
  ),
  ButtonCloseMobile: ({ onClick }) => (
    <Button btnType="secondary" onClick={onClick} isFullWidth>
      <FormattedMessage id="collapsible.hide" />
    </Button>
  ),
  defaultOpened: false,
  isOpen: false,
};
/* eslint-enable */

class Collapsible extends Component {
  constructor(props) {
    super(props);
    const { defaultOpened } = props;
    this.state = {
      isOpen: defaultOpened,
      height: defaultOpened ? 'auto' : 0,
    };
    this.toggleOpenClose = this.toggleOpenClose.bind(this);
    this.getInnerRef = this.getInnerRef.bind(this);
    this.updateAfterTransition = this.updateAfterTransition.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { isOpen } = this.state;
    const { onChange, defaultOpened } = this.props;

    if (isOpen !== prevState.isOpen && onChange) {
      onChange(isOpen);
    }
    if (prevState.height === 'auto' && this.state.height !== 'auto') {
      setTimeout(() => this.setState({ height: '0px' }), 1);
    }
    if (prevProps.defaultOpened !== defaultOpened) {
      this.toggleOpenClose();
    }
  }

  getInnerRef(node) {
    this.innerRef = node;
  }

  toggleOpenClose() {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate -- node upgrade
      isOpen: !this.state.isOpen,
      height: this.innerRef.scrollHeight,
    });
  }

  updateAfterTransition(e) {
    e.stopPropagation();
    if (this.state.isOpen) {
      this.setState({ height: 'auto' });
    }
  }

  render() {
    const {
      children,
      Title,
      ContentWrapper,
      ButtonOpen,
      ButtonClose,
      ButtonCloseMobile,
      type,
      mod,
      isDisabled,
    } = this.props;
    const { isOpen, height } = this.state;
    const blockClassname = cx({
      collapsible: true,
      [`collapsible--${type}`]: type,
      [`collapsible--${type}-${mod}`]: type && mod,
      'collapsible--state-open': isOpen,
    });

    return (
      <div className={blockClassname}>
        <div className="collapsible__header">
          <Title onClick={this.toggleOpenClose} isOpen={isOpen} />
          <div className="collapsible__header-close">
            <ButtonClose onClick={this.toggleOpenClose} />
          </div>
          <div className="collapsible__header-open">
            <ButtonOpen onClick={this.toggleOpenClose} isDisabled={isDisabled} />
          </div>
        </div>
        <ContentWrapper>
          <div
            className="collapsible__content"
            style={{
              height,
              overflow: height === 'auto' ? 'visible' : 'hidden',
              transition: 'height 250ms linear 0s',
            }}
            onTransitionEnd={this.updateAfterTransition}
            ref={this.getInnerRef}
          >
            <div className="collapsible__content-inner">
              {children}
            </div>
          </div>
        </ContentWrapper>
        <footer className="collapsible__footer">
          <ButtonCloseMobile onClick={this.toggleOpenClose} />
        </footer>
      </div>
    );
  }
}

Collapsible.propTypes = propTypes;
Collapsible.defaultProps = defaultProps;

export default Collapsible;
